import { Button } from '../../components/Button';
import { clx } from '../../lib/utils';

interface IContinueButtonProps {
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}

export const ContinueButton = ({ className, disabled, onClick }: IContinueButtonProps) => {
  return (
    <div className={clx('h-30 mt-auto shrink-0 pt-8', className)}>
      <Button
        variant="buttonPrimary"
        className="bg-cta-primary disabled:bg-cta-primary/50 mx-auto flex h-16 w-full items-center justify-center text-[1.375rem] font-semibold drop-shadow"
        type="submit"
        disabled={disabled ?? false}
        onClick={onClick}
      >
        Continue
      </Button>
    </div>
  );
};
